import { axiosGet } from "../../react_axios/Axios";
import moment from "moment";
import { DUE_PAYMENT_LIST_ACTION_TYPE, duePaymentListUrl, headers } from "../../utils/constants";

export const due_payment_list_action =
  (OrderID, CompanyName,ItmeCenter) => async (dispatch) => {
    try {
      const mapdata = {
        userId: sessionStorage.getItem("userId"),
        OrderID: OrderID,
        CompanyName: CompanyName,
        ItmeCenter: ItmeCenter,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        OrderID: mapdata.OrderID === "" ? null : mapdata.OrderID,
        CompanyName: mapdata.CompanyName === "" ? null : mapdata.CompanyName,
        ItmeCenter: mapdata.ItmeCenter === "" ? null : mapdata.ItmeCenter,
      };
      console.log("Due Payment mapdata...", mapdata);
      const res = await axiosGet(duePaymentListUrl, params,headers);
      console.log("Due Payment", res);
      dispatch({
        type: DUE_PAYMENT_LIST_ACTION_TYPE,
        payload: res,
      });
      return res;
    } catch (err) {
      return Promise.reject(err);
    }
  };